import { render, staticRenderFns } from "./GridComponent.vue?vue&type=template&id=67d7b070&"
import script from "./GridComponent.vue?vue&type=script&lang=ts&"
export * from "./GridComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GridComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports